(() => {
  const elementName = 'ifa-before-arrival';

  if (customElements.get(elementName)) return;

  class IfaBeforeArrival extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();

      const { signal } = this.abortController;
      this.items = Array.from(this.querySelectorAll('[data-ifa-09-item]'))
        .map((item) => ({
          item,
          button: item.querySelector('[data-ifa-09-toggle]'),
          panel: item.querySelector('[data-ifa-09-panel]'),
        }))
        .filter(({ button, panel }) => button && panel);

      this.items.forEach((entry) => {
        this.setExpanded(entry, false);
        entry.button.addEventListener('click', (event) => this.onToggle(event), { signal });
        entry.button.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      });

      this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = undefined;
      this.items = [];
    }

    onToggle(event) {
      const entry = this.items.find(({ button }) => button === event.currentTarget);
      if (!entry) return;

      const shouldOpen = entry.button.getAttribute('aria-expanded') !== 'true';
      this.items.forEach((item) => this.setExpanded(item, false));

      if (shouldOpen) this.setExpanded(entry, true);

      this.dispatchEvent(new CustomEvent('ifa:faq-toggle', {
        bubbles: true,
        detail: {
          sectionId: this.dataset.sectionId,
          blockId: entry.item.dataset.blockId,
          expanded: shouldOpen,
        },
      }));
    }

    onKeydown(event) {
      const navigationKeys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
      if (!navigationKeys.includes(event.key)) return;

      const currentIndex = this.items.findIndex(({ button }) => button === event.currentTarget);
      if (currentIndex < 0) return;

      event.preventDefault();

      let nextIndex = currentIndex;
      if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.items.length;
      if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.items.length) % this.items.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.items.length - 1;

      this.items[nextIndex].button.focus();
    }

    onBlockSelect(event) {
      const item = event.target.closest('[data-ifa-09-item]');
      if (!item || !this.contains(item)) return;

      const selectedEntry = this.items.find((entry) => entry.item === item);
      if (!selectedEntry) return;

      this.items.forEach((entry) => this.setExpanded(entry, entry === selectedEntry));
    }

    setExpanded({ item, button, panel }, expanded) {
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      panel.hidden = !expanded;
      item.dataset.expanded = expanded ? 'true' : 'false';
    }
  }

  customElements.define(elementName, IfaBeforeArrival);
})();
